import { APIIcon, ArrowUp, Consult, DocIcon, Planet } from "@/components/Icons";
import { ChakraProps, Button, ButtonProps, chakra } from "@chakra-ui/react";

export interface BtnProps {
  theme: "blue" | "white" | "blueTag";
  text: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  icon?: "consult" | "arrowUp" | "doc" | "api" | "planet";
  name?: string;
}

const blueStyle: ButtonProps = {
  bg: "#165DFF",
  w: "114px",
  _hover: { bg: "#165DFF", opacity: 0.75 },
  _active: { bg: "#165DFF", opacity: 0.75 },
  borderColor: "#165DFF",
  css: {
    "& svg": {
      fill: "white",
      stroke: "white",
    },
  },
};
const whiteStyle: ButtonProps = {
  variant: "solid",
  w: "114px",
  bg: "white",
  color: "#4E5969",
  borderColor: "#C9CDD4",
  _hover: {
    color: "#165DFF",
    borderColor: "#165DFF",
  },
  css: {
    "& svg": {
      fill: "currentcolor",
      stroke: "currentcolor",
    },
  },
};

const blueTagStyle: ButtonProps = {
  bg: "#165DFF19",
  color: "#165DFF",
  rounded: "full",
  h: "fit-content",
  _hover: { bg: "#165DFF19", opacity: 0.75 },
  _active: { bg: "#165DFF19", opacity: 0.75 },
  borderColor: "transparent",
  p: "5px 16px",
  css: {
    "& svg": {
      fill: "#165DFF",
      stroke: "#165DFF",
    },
  },
};

function getStyle(theme: BtnProps["theme"]) {
  switch (theme) {
    case "blue":
      return blueStyle;
    case "white":
      return whiteStyle;
    case "blueTag":
      return blueTagStyle;
  }
}
function getIcon(icon: BtnProps["icon"]) {
  switch (icon) {
    case "consult":
      return <Consult boxSize="16px" mr="0.5em" />;
    case "arrowUp":
      return <ArrowUp boxSize="16px" mr="0.5em" />;
    case "doc":
      return <DocIcon boxSize="16px" mr="0.5em" />;
    case "api":
      return <APIIcon boxSize="16px" mr="0.5em" />;
    case "planet":
      return <Planet boxSize="16px" mr="0.5em" />;
    default:
      return null;
  }
}
function BusinessButton(props: BtnProps) {
  const { theme, text, icon, onClick, name = "", ...styles } = props;
  return (
    <Button name={name} onClick={onClick} {...getStyle(theme)} mr="1em" {...styles}>
      {getIcon(icon)}
      {text}
    </Button>
  );
}

export default chakra(BusinessButton);
